import { render, staticRenderFns } from "./DuwaTable.vue?vue&type=template&id=0126cf6e"
import script from "./DuwaTable.vue?vue&type=script&lang=js"
export * from "./DuwaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports